export const SPONSORSHIP_QUERY_KEYS = {
  all: ["sponsorship"] as const,
  balance: () => ["sponsorship", "balance"] as const,
  redemptions: (page = 1) => ["sponsorship", "redemptions", page] as const,
  allRedemptions: () => ["sponsorship", "redemptions"] as const,
  campaign: () => ["sponsorship", "campaign"] as const,
  recommendations: () => ["sponsorship", "recommendations"] as const,
  terms: () => ["sponsorship", "terms"] as const,
};
